import { ModeDocumentsPageType } from '../types';

export const useModeDocumentsPage = (mode: ModeDocumentsPageType) => {
    return {
        isShared: mode === 'shared',
        isDeleted: mode === 'deleted',
        isDocuments: mode === 'documents',
    };
};
